(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b-text-carousel"] && !window.DesignMode) return;
  try {
    

    class ProductCarousel extends HTMLElement {
        constructor() {
            super()
            this.slider = this.querySelector('[data-product-carousel-slider]')
            this.sliderItems = this.querySelectorAll('[data-product-carousel-item]')
            this.sliderContent = this.querySelector('[data-product-carousel-content]')
            this.sliderDescriptions = this.querySelectorAll('[data-product-carousel-description]')
            this.currentIndex = 0
            this.currentItem = this.sliderItems[this.currentIndex]
            this.currentDescription = this.sliderDescriptions[this.currentIndex]
            this.currentDescription.classList.add('is-selected')

            this.setSlideWidth()
            window.addEventListener('resize', () => this.setSlideWidth())

            this.init()
        }
        setSlideWidth() {
            const totalItems = this.sliderItems.length - 1

            if (totalItems > 4) {
                this.slider.style.setProperty('--slide-width-sm', 'calc(100% * 1/5)');
            }

            if (totalItems > 6) {
                this.slider.style.setProperty('--slide-width-md', 'calc(100% * 1/7)');
            }
        }

        init() {
            this.flickity = new Flickity(this.slider, {
                cellAlign: 'center',
                draggable: '>2',
                dragThreshold: 30,
                friction: 0.35,
                groupCells: false,
                initialIndex: 0,
                percentPosition: true,
                prevNextButtons: true,
                pageDots: false,
                resize: true,
                // setGallerySize: true,
                wrapAround: true
            });

            this.setNavButtons()
            this.getSiblings()

            this.flickity.on('change', () => this.getCurrent())

            let minHeight = 0

            this.sliderDescriptions.forEach((desc, i, array) => {
                let tmpHeight = desc.clientHeight
                minHeight = tmpHeight > minHeight ? tmpHeight : minHeight
            })

            this.sliderContent.style.minHeight = `${minHeight}px`

        }

        getCurrent() {
            this.currentIndex = this.flickity.selectedIndex
            this.currentItem = this.sliderItems[this.currentIndex]
            this.currentDescription = this.sliderDescriptions[this.currentIndex]

            this.sliderDescriptions.forEach(descr => descr.classList.remove('is-selected'))
            this.currentDescription.classList.add('is-selected')

            this.updateNavBtns()
        }

        getSiblings() {
            this.currentSiblings = {
                prev: this.currentItem.getAttribute('data-product-carousel-prev'),
                next: this.currentItem.getAttribute('data-product-carousel-next')
            }
        }

        setNavButtons() {
            this.navButtons = this.querySelectorAll('.flickity-prev-next-button')
            this.prevButton = this.querySelector('.flickity-prev-next-button.previous')
            this.nextButton = this.querySelector('.flickity-prev-next-button.next')

            const prevProduct = document.createElement('span')
            const nextProduct = document.createElement('span')

            this.navButtons.prevProduct = prevProduct
            this.navButtons.nextProduct = nextProduct

            this.prevButton.appendChild(prevProduct)
            this.nextButton.appendChild(nextProduct)
            this.updateNavBtns()
        }

        updateNavBtns() {
            this.getSiblings()

            this.navButtons.prevProduct.textContent = this.currentSiblings.prev
            this.navButtons.nextProduct.textContent = this.currentSiblings.next
        }
    }

    customElements.define('product-carousel', ProductCarousel)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["l-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('l-product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('l-product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
